import * as React from 'react';
import { useContext } from 'react';
import SvgImage from '../SvgImage';
import { Contacts } from '../../../typings';
import LocalizationContext from '../../../contexts/Localizations';
import './styles.scss';

interface ContactProps {
  contact: Contacts;
  containerTheme: string;
}

const Contact = ({
  contact,
  containerTheme,
}: ContactProps) => {
  const { translations } = useContext(LocalizationContext);
  // Adds space between every characters apart from (0)
  // Required for screen readers to read phone numbers properly and include all character
  const toReadable = (phoneNumber: string): string => phoneNumber
    .split(' ')
    .join('')
    .split('')
    .join(' ')
    .replace('( 0 )', '(0)');

  return (
    <div className={`contact contact--${containerTheme}`}>
      <h3 className="contact__title">
        {translations.contact.title}
      </h3>

      <ul className="contact__list">
        {(contact.addr && contact.addr.length) && (
          <li className="contact__item">
            <span className="contact__label">
              {`${translations.contact.addr}:`}
            </span>
            {contact.addr}
          </li>
        )}
        {(contact.tel && contact.tel.length) && (
          <li className="contact__item">
            <span className="contact__label">
              {`${translations.contact.tel}:`}
            </span>
            <a className="contact__link" href={`tel:${contact.tel}`} aria-label={toReadable(contact.tel)}>
              {contact.tel}
            </a>
          </li>
        )}
        {(contact.fax && contact.fax.length) && (
          <li className="contact__item">
            <span className="contact__label">
              {`${translations.contact.fax}:`}
            </span>
            <a className="contact__link" href={`fax:${contact.fax}`} aria-label={toReadable(contact.fax)}>
              {contact.fax}
            </a>
          </li>
        )}
        {(contact.email && contact.email.length) && (
          <li className="contact__item">
            <span className="contact__label">
              {`${translations.contact.email}:`}
            </span>
            <a className="contact__link" href={`mailto:${contact.email}`}>
              {contact.email}
            </a>
          </li>
        )}
        {(contact.website && contact.website.length) && (
          <li className="contact__item">
            <span className="contact__label">
              {`${translations.contact.website}:`}
            </span>
            <a className="contact__link" href={contact.website} target="_blank" rel="noreferrer">
              {contact.website}
            </a>
          </li>
        )}
        <li className="contact__item">
          <ul className="contact__social">
            {(contact.facebook && contact.facebook.length) && (
              <li className="contact__social-item">
                <a className="contact__social-link" target="_blank" rel="noreferrer" href={contact.facebook}>
                  <SvgImage title="Facebook" reference="#icon-facebook" />
                </a>
              </li>
            )}
            {(contact.instagram && contact.instagram.length) && (
              <li className="contact__social-item">
                <a className="contact__social-link" target="_blank" rel="noreferrer" href={contact.instagram}>
                  <SvgImage title="Instagram" reference="#icon-instagram" />
                </a>
              </li>
            )}
            {(contact.twitter && contact.twitter.length) && (
              <li className="contact__social-item">
                <a className="contact__social-link" target="_blank" rel="noreferrer" href={contact.twitter}>
                  <SvgImage title="Twitter" reference="#icon-twitter" />
                </a>
              </li>
            )}
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default Contact;
